/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components/macro";
import { Link } from "react-router-dom";
import * as Yup from "yup";
import PropTypes from "prop-types";
import { Formik } from "formik";
import axios from "../../CustomAxios";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
  Box,
  CircularProgress,
} from "@mui/material";
import { spacing } from "@mui/system";

import { connect } from "react-redux";
import { loginUser, loadUser } from "../../actions/AuthActions";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);

function ApUser({
  setEmail,
  loginUser,
  auths,
  loadUser,
  setState,
  setVerification,
  setOtp,
}) {
  const [err, setErr] = useState("");
  const navigate = useNavigate();

  React.useEffect(async () => {
    if (auths.token) {
      const data = await loadUser();
      if (data.success) {
        navigate("/dashboard/tasks");
      }
    }
  }, []);

  const login = async (user) => {
    try {
      const { data } = await axios.post(`/api/v1/ap_user/auth/login`, {
        email_address: user.email_address,
        password: user.password,
      });
      // console.log(data);
      if (data.success) {
        setVerification(data.verification_key);
        if(data.otp_code){
          setOtp(data.otp_code);
        }
        // setOtp(data.otp_code);
        setState(1);
        setEmail(user.email_address);
      }
    } catch (e) {
      console.log(e);
      if (e.response.data.error) {
        setErr(e.response.data.error);
      } else {
        setErr("Server Error");
      }
    }
  };

  return (
    <Formik
      initialValues={{
        email: "",
        password: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
        password: Yup.string().max(255).required("Password is required"),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          const user = {
            email_address: values.email,
            password: values.password,
            type: "ap_user",
          };
          login(user);
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={3} severity="warning">
              {errors.submit}
            </Alert>
          )}
          {err ? (
            <Alert mt={2} mb={3} severity="error">
              {err}
            </Alert>
          ) : null}

          <TextField
            type="email"
            name="email"
            label="Email Address"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <TextField
            type="password"
            name="password"
            data-testid="password"
            label="Password"
            value={values.password}
            error={Boolean(touched.password && errors.password)}
            fullWidth
            helperText={touched.password && errors.password}
            onBlur={handleBlur}
            onChange={handleChange}
            my={2}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? (
              <>
                Signing In &nbsp;
                <CircularProgress size={20} color="primary" />
              </>
            ) : (
              "Sign in"
            )}
          </Button>
          <Box
            component={"span"}
            m={1}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Button component={Link} to="/login" color="primary">
              Login as Customer User
            </Button>
            <Button
              style={{ textAlign: "right" }}
              component={Link}
              to="/reset-password?user=ap_user"
              color="primary"
            >
              Forgot password
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
}

ApUser.propTypes = {
  loginUser: PropTypes.func.isRequired,
  auths: PropTypes.object.isRequired,
  loadUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, { loginUser, loadUser })(ApUser);
